## for API
SSOInitRequest:
  content:
    application/json:
      schema:
        required:
          - code
          - service
          - service_key
        type: object
        properties:
          service:
            description: APIキーのservice
            type: string
            example: directcloud
          service_key:
            description: APIキーのservice_key
            type: string
          code:
            description: 会社ID
            type: string

TokenRequest:
  content:
    multipart/form-data:
      schema:
        required:
          - code
          - id
          - password
          - service
          - service_key
        type: object
        properties:
          service:
            description: APIキーのservice
            type: string
            example: directcloud
          service_key:
            description: APIキーのservice_key
            type: string
          code:
            description: 会社ID
            type: string
          id:
            description: ユーザーID
            type: string
          password:
            description: パスワード
            type: string

AccessTokenRequest:
  content:
    multipart/form-data:
      schema:
        required:
          - access_key
          - service
          - service_key
        type: object
        properties:
          service:
            description: APIキーのservice
            type: string
            example: directcloud
          service_key:
            description: APIキーのservice_key
            type: string
          access_key:
            description: access_key
            type: string

TokenExpireRequest:
  content:
    multipart/form-data:
      schema:
        required:
          - service
          - service_key
          - access_token
        type: object
        properties:
          service:
            description: APIキーのservice
            type: string
            example: directcloud
          service_key:
            description: APIキーのservice_key
            type: string
          access_token:
            description: | 
              破棄するaccess_token
              - すでに破棄されている、または存在しないaccess_tokenを指定してリクエストしても、破棄成功（Code 200）のレスポンスが返されます。
            type: string

CreateFolderRequest:
  content:
    multipart/form-data:
      schema:
        required:
          - name
        type: object
        properties:
          name:
            description: 追加するフォルダ名
            type: string
            example: DirectCloud

RenameFolderRequest:
  content:
    multipart/form-data:
      schema:
        required:
          - name
        type: object
        properties:
          name:
            description: 変更後のフォルダ名
            type: string
            example: DirectCloud

DeleteFolderRequest:
  content:
    multipart/form-data:
      schema:
        required:
          - node
        type: object
        properties:
          node:
            description: 削除対象のフォルダ識別コード
            type: string
            example: 1{2021

MoveFolderRequest:
  content:
    multipart/form-data:
      schema:
        required:
          - nodes
        type: object
        properties:
          nodes:
            description: |
              {target node}|{destination node}
                - target node: 移動対象フォルダのノード
                - destination node: 移動先フォルダのノード
            example: 1{2AAABBB|1{2ABCB


FilesRequest:
  content:
    multipart/form-data:
      schema:
        type: object
        properties:
          sort:
            description: 照会するファイル整列方法
            type: string
            default: -name
            enum:
              - +name
              - -name
              - +datetime
              - -datetime
              - +size
              - -size
          limit:
            description: 一度に照会するファイルの数
            type: number
            default: 100
          offset:
            description: 照会から除外する数
            type: number
            default: 0

UploadFileRequest:
  content:
    application/octet-stream:
      schema:
        required:
          - Filedata
        type: object
        properties:
          Filedata:
            description: アップロードするデータ(バイナリー)
            type: string
            format: binary

RenameFileRequest:
  content:
    multipart/form-data:
      schema:
        required:
          - file_seq
          - name
        type: object
        properties:
          file_seq:
            description: ファイル識別コード
            type: number
          name:
            description: 変更後のファイル名
            type: string

DownloadFileRequest:
  content:
    multipart/form-data:
      schema:
        required:
          - file_seq
        type: object
        properties:
          file_seq:
            description: ファイル識別コード
            type: number
          flag_direct:
            description: |
              バイナリファイルを直接表示させるかどうか(Y:バイナリデータを表示、N:ダウンロードアドレスを表示)
            type: string
            default: N
            enum:
              - Y
              - N

DeleteFileRequest:
  content:
    multipart/form-data:
      schema:
        required:
          - file_seq
        type: object
        properties:
          file_seq:
            description: ファイル識別コード。複数ファイルを削除する場合は、カンマ(,)で区切って指定します。
            type: number

MoveFileRequest:
  content:
    multipart/form-data:
      schema:
        required:
          - fids
        type: object
        properties:
          fids:
            description: |
              {file_seq}|{node}
              `{ファイル識別コード}|{ノード}` の形式で指定します。
                - file_seq: ファイル識別コード
                - node: 移動先のフォルダのノード
            example: 1111|1{2ABC

SearchFileRequest:
  content:
    multipart/form-data:
      schema:
        required:
          - keyword
        type: object
        properties:
          keyword:
            description: 検索するファイルの検索ワード
            type: string
          sort:
            description: |
              照会するファイルの並べ替え方法。(ファイル名:+name/-name、更新日:+datetime/-datetime、サイズ:+size/-size)
            type: string
            default: -name
            enum:
              - +name
              - -name
              - +datetime
              - -datetime
              - +size
              - -size
          limit:
            description: |
              一度に照会するファイル数(デフォルト値: 100, 最大値:1000)
            type: number
            default: 100
            maximum: 1000
          offset:
            description: 照会から除外する数
            type: number # sting? If yes change all.
            default: 0

CreateLinkRequest:
  content:
    multipart/form-data:
      schema:
        required:
          - target_type
          - target_seq
          - view_option
        type: object
        properties:
          target_type:
            description: リンク生成対象の種別（フォルダー：folder, ファイル：file）
            type: string
            enum:
              - folder
              - file
          target_seq:
            description: リンク生成対象のファイル・フォルダの識別コード（フォルダ：dir_seq, ファイル：file_seq）
            type: number
          view_option:
            description: アクセスレベル（ダウンロード：download, 閲覧：preview, 閲覧後にダウンロード：both）
            type: string
            enum:
              - both
              - download
              - preview
          expiration_date:
            description: 有効期限 (YYYY-MM-DD)
            type: string
          limit_count:
            description: アクセス回数制限（デフォルト：0）
            type: number
          password:
            description: パスワード
            type: string
          flag_readable:
            description: |
              アクセスレベルの使用可否（使用する：Y, 使用しない：N）
            type: string
          flag_writable:
            description: |
              アップロードの使用可否(使用する：Y、使用しない：N) ※容量上限は「制限なし」で固定
            type: string

CreateViewerRequest:
  content:
    multipart/form-data:
      schema:
        required:
          - file_seq
        type: object
        properties:
          file_seq:
            description: ビューアを作成するファイルの識別コード
            type: number

## for Admin API
CompanyCreateRequest:
  content:
    application/x-www-form-urlencoded:
      schema:
        required:
          - code
          - name
          - phone
          - company_email
          - contact_name
          - id
          - email
          - cell_phone
          - item_code
        $ref: '#/components/schemas/Company'

CompanyModifyRequest:
  content:
    application/json:
      schema:
        required:
          - company_seq
        $ref: '#/components/schemas/CompanyEdit'

## for Manager API
ManagerTokenRequest:
  content:
    multipart/form-data:
      schema:
        required:
          - code
          - id
          - password
          - service
          - service_key
        type: object
        properties:
          service:
            type: string
            description: APIキーのservice
            example: directcloud
          service_key:
            type: string
            description: APIキーのservice_key
          code:
            type: string
            description: 会社ID
          id:
            type: string
            description: 管理者ID
          password:
            type: string
            description: パスワード

UserCreateRequest:
  content:
    multipart/form-data:
      schema:
        required:
          - id
          - password
          - name
          - email
        type: object
        properties:
          id:
            type: string
            description: |
              ユーザーID
              - 【例】testuser
          password:
            type: string
            description: |
              パスワード
              - 【例】abcde12345
          name:
            type: string
            description: |
              名前
              - 【例】山田太郎
          lang:
            type: string
            description: |
              言語
              - 【内訳】 jpn、kor、eng
          email:
            type: string
            description: |
              メールアドレス
              - 【例】test@directcloud.co.jp
          volume_size:
            type: number
            description: |
              割当容量
              - 【例】1024
              - 【デフォルト値】10
          role_name:
            type: string
            description: |
              ユーザータイプ
              - 【内訳】契約管理者：SUPERUSER、一般管理者：MANAGER、ユーザー：USER、ゲスト：GUEST
              - 【デフォルト値】USER
          phone:
            type: string
            description: |
              携帯電話
              - 【例】000-1111-2222
          gmt:
            type: string
            description: |
              GMT変更
              - 【例】+9
          flag_expire:
            type: string
            description: |
              有効期限のチェック
              - 【内訳】Y、N
              - 【デフォルト値】N
          expire:
            type: string
            description: |
              有効期限の日付
              - 【例】2022-12-31

UserUpdateRequest:
  content:
    multipart/form-data:
      schema:
        name: Update A User
        type: object
        required:
          - name
          - email
        properties:
          name:
            type: string
            description: |
              名前
              - 【例】山田太郎
          email:
            type: string
            description: |
              メールアドレス
              - 【例】test@directcloud.co.jp
          password:
            type: string
            description: |
              パスワード
              - 【例】abcde12345
          lang:
            type: string
            description: |
              言語
              - 【内訳】 jpn、kor、eng
          volume_size:
            type: number
            description: |
              割当容量
              - 【例】1024
              - 【デフォルト値】10
          role_name:
            type: string
            description: |
              ユーザータイプ
              - 【内訳】契約管理者：SUPERUSER、一般管理者：MANAGER、ユーザー：USER、ゲスト：GUEST
              - 【デフォルト値】USER
            enum:
              - SUPERUSER
              - MANAGER
              - USER
              - GUEST
          phone:
            type: string
            description: |
              携帯電話
              - 【例】000-1111-2222
          gmt:
            type: string
            description: |
              GMT変更
              - 【例】+9
          flag_expire:
            type: string
            description: |
              有効期限のチェック
              - 【内訳】Y、N
              - 【デフォルト値】N
          expire:
            type: string
            description: |
              有効期限の日付
              - 【例】2022-12-31
          status:
            type: string
            description: |
              ステータス
              - 【内訳】有効：11、無効：41、アカウントロック：51

UserDeleteRequest:
  content:
    multipart/form-data:
      schema:
        name: Delete A User
        type: object
        required:
          - user_seq
        properties:
          user_seq:
            type: number
            description: ユーザー識別コード

GroupCreateRequest:
  content:
    multipart/form-data:
      schema:
        name: Creaet A Group
        type: object
        required:
          - parent_group_seq
          - name
        properties:
          parent_group_seq:
            type: number
            description: 親グルーブのグループ識別コード
          name:
            type: string
            description: グループ名

GroupUpdateRequest:
  content:
    multipart/form-data:
      schema:
        name: Update A Group
        type: object
        required:
          - name
        properties:
          name:
            type: string
            description: 変更後のグループ名

GroupDeleteRequest:
  content:
    multipart/form-data:
      schema:
        required:
          - group_seq
        name: Delete A Group
        type: object
        properties:
          group_seq:
            type: number
            description: グルーブ識別コード

RelationCreateRequest:
  content:
    multipart/form-data:
      schema:
        name: Create A Relation
        type: object
        required:
          - user_seq
          - group_seq
        properties:
          user_seq:
            type: number
            description: ユーザー識別コード
          group_seq:
            type: number
            description: グループ識別コード

RelationDeleteRequest:
  content:
    multipart/form-data:
      schema:
        name: Delete A Relation
        type: object
        required:
          - user_seq
          - group_seq
        properties:
          user_seq:
            type: number
            description: ユーザー識別コード
          group_seq:
            type: number
            description: グループ識別コード

FolderPermissionRequest:
  content:
    multipart/form-data:
      schema:
        name: Add Permission To A Folder
        type: object
        required:
          - node
          - target_seq
          - target_type
          - permission_name
        properties:
          node:
            type: string
            description: アクセス権追加対象のフォルダ識別コード
          target_seq:
            type: number
            description: アクセス権付与対象のグルーブの識別コード、もしくはユーザーの識別コード
          target_type:
            type: string
            description: アクセス権付与対象の種別（G：グループ、 U：ユーザー）
          permission_name:
            type: string
            description: |
              付与するアクセス権の名前（owner：オーナー、 editor：編集者、 editor2：編集者－、 viewer：ダウンローダー、 uploader：アップローダー、 uploader2：閲覧者+、 previewer：閲覧者、 NoAccess: アクセス権の除外）
            enum:
              - owner
              - editor
              - editor2
              - uploader
              - uploader2
              - viewer
              - previewer

UpdateFolderPermissionRequest:
  content:
    multipart/form-data:
      schema:
        name: Update A Folder Permission
        type: object
        required:
          - dir_permission_seq
          - permission_name
        properties:
          dir_permission_seq:
            type: number
            description: アクセス権の識別コード
          permission_name:
            type: string
            description: 付与するアクセス権の名前

DeleteFolderPermissionRequest:
  content:
    multipart/form-data:
      schema:
        name: Delete A Folder Permission
        type: object
        required:
          - dir_permission_seq
        properties:
          dir_permission_seq:
            type: number
            description: アクセス権の識別コード

PermissionInheritAccessSettingRequest:
  content:
    multipart/form-data:
      schema:
        name: Permission Inherit Access Setting
        type: object
        required:
          - node
          - inherit_permission
        properties:
          node:
            type: string
            description: 設定対象のフォルダノード
          inherit_permission:
            type: boolean
            description: |
              継承するかどうかの設定値
              - true：継承する　false：継承しない

components:
  schemas:
    Company:
      type: object
      properties:
        code:
          type: string
          description: 会社コード
        name:
          type: string
          description: 会社名
        phone:
          type: string
          description: 電話番号
        company_email:
          type: string
          description: 代表メールアドレス
        contact_name:
          type: string
          description: 契約担当者の名前
        id:
          type: string
          description: 契約担当者ID
        password:
          type: string
          description: 契約担当者パスワード
        email:
          type: string
          description: 契約担当者 メール
        cell_phone:
          type: string
          description: 契約担当者の電話番号
        item_code:
          type: string
          description: 締結契約(Lite固定)
        post_no:
          type: string
          description: 郵便番号
        address:
          type: string
          description: 住所
        scale:
          type: string
          description: 会社規模
          enum:
            - "1 - 50名"
            - "51 -　100名"
            - "101 - 500名"
            - "500 - 1,000名"
            - "1,000名以上"
        country_code:
          type: string
          description: 国家コード
          default: jpn
        gmt:
          type: string
          description: GMT(Grennwich Mean Time) 情報
          default: " +9" # TODO: finish me
        admin_seq:
          type: number
          description: 販売会社の固有番号
        use_trial:
          type: string
          description: 体験版(Trial) 使用可否(boxadmin)
          enum:
            - Y
            - N
          default: N
        start_date:
          type: string
          description: 使用開始日
          example: "2021-08-16"
        end_date:
          type: string
          description: 使用終了日
          example: "2026-09-09"
        use_compaign:
          type: string
          description: キャンペーン使用可否
          enum:
            - Y
            - N
          default: Y
        compaign_end_date:
          type: string
          description: キャンペーン終了日
        status:
          type: string
          description: |
            常態
            - 0 : 未認証
            - 10 : 無料
            - 11 : 有料
            - 41 : 使用停止
            - 91 : 削除
            - 92 : 脱退
        payment_type:
          type: string
          description: 支払方法
          enum:
            - yearly
            - monthly
            - no_charge
          default: monthly
        volume_size:
          type: number
          description: 容量(Byte)
          default: 0
        limit_traffic:
          type: number
          description: トラフィック(Byte)
        #          default: 10737418240
        max_upload_size:
          type: number
          description: 最大アップロードサイズ(Byte)
        #          default: 5368709120
        max_preview_size:
          type: number
          description: プレビューできる最大サイズ(Byte)
        #          default: 31457280
        max_media_preview_size:
          type: number
          description: メディアプレビュー可能な最大サイズ(Byte)
        #          default: 10737418240
        license_amount:
          type: string
          description: |
            ユーザー制限数
            - **0**: 無制限
        csv_upload_limit:
          type: number
          description: CSV一括登録アップロード行数制限(500~10,000)
        use_my_box:
          type: string
          description: My Box 使用の可否
          enum:
            - Y
            - N
          default: Y
        use_shared_box:
          type: string
          description: Shared Box 使用の可否
          enum:
            - Y
            - N
          default: N
        use_tag:
          type: string
          description: タグ機能の使用可否
          enum:
            - Y
            - N
          default: N
        use_available_comment:
          type: string
          description: ファイル別コメント使用可否
          enum:
            - Y
            - N
          default: N
        use_available_guest_invite:
          type: string
          description: Guest招待使用可否
          enum:
            - Y
            - N
          default: N
        flag_quota_limit:
          type: string
          description: Shared Box容量制限/自動削除の使用可否
          enum:
            - Y
            - N
          default: N
        use_available_master:
          type: string
          description: Shared Box マスター権限使用可否
          enum:
            - Y
            - N
          default: N
        use_available_master_start_date:
          type: string
          description: Shared Box副管理者権限使用開始日
        use_available_master_end_date:
          type: string
          description: Shared Box副管理者権限使用終了日
        use_available_master_user_count:
          type: number
          description: Shared Box副管理者権限最大数
        use_available_master_permission_detail:
          type: string
          description: Shared Box副管理者権限詳細設定
          enum:
            - Y
            - N
          default: N
        flag_uploadrequest:
          type: string
          description: アップロードリクエストの使用可否
          enum:
            - Y
            - N
          default: N
        use_avialable_otp:
          type: string
          description: 2段階認証(email)の使用可否
          enum:
            - Y
            - N
          default: N
        use_available_offline:
          type: string
          description: モバイルオフライン使用可否
          enum:
            - Y
            - N
          default: N
        use_zipmail:
          type: string
          description: ファイル添付メール送信の使用可否
          enum:
            - Y
            - N
          default: N
        use_available_domain:
          type: string
          description: 会社別サブドメイン使用可否
          enum:
            - Y
            - N
          default: N
        use_available_wf:
          type: string
          description: ワークフロー使用可否
          enum:
            - Y
            - N
          default: N
        use_available_smtp:
          type: string
          description: 会社別メール送信サーバー使用可否
          enum:
            - Y
            - N
          default: N
        use_available_file_permission:
          type: string
          description: ファイルロックの使用可否
          enum:
            - Y
            - N
          default: Y
        use_two_factor_sms:
          type: string
          description: 2段階認証(SMS)使用可否
          enum:
            - Y
            - N
          default: N
        use_session_log:
          type: string
          description: セッション履歴の使用可否
          enum:
            - Y
            - N
          default: N
        use_finder:
          type: string
          description: 全文検索の使用可否
          enum:
            - Y
            - N
          default: N
        use_available_editor:
          type: string
          description: 共同文書編集の使用可否
          enum:
            - Y
            - N
          default: N
        use_available_editor_start_date:
          type: string
          description: オンライン編集の使用開始日付
        use_available_editor_end_date:
          type: string
          description: オンライン編集の使用終了日付
        use_upload_alarm_one_term:
          type: string
          description: 通知メール1分ごとに通知使用可否
          enum:
            - Y
            - N
          default: N
        use_available_link_default:
          type: string
          description: リンク初期値オプション高度化
          enum:
            - Y
            - N
          default: N
        use_available_upload_alarm_custom:
          type: string
          description: 新規ファイルアップロード通知メールカスタム
          enum:
            - Y
            - N
          default: N
        use_available_audit:
          type: string
          description: 監査エディション
          enum:
            - Y
            - N
          default: N
        use_dashboard:
          type: string
          description: ダッシュボード使用可否
          enum:
            - Y
            - N
          default: N
        use_dashboard_extension:
          type: string
          description: ダッシュボード詳細使用可否
          enum:
            - Y
            - N
          default: N
        use_dashboard_start_date:
          type: string
          description: ダッシュボード(VISIBLE)詳細使用開始日付
        use_dashboard_end_date:
          type: string
          description: ダッシュボード(VISIBLE)詳細使用終了日付
        use_available_shield:
          type: string
          description: SHIELD使用可否(Boxadmin)
          enum:
            - Y
            - N
          default: N
        use_available_shield_extension:
          type: string
          description: SHIELD正式版の使用可否
          enum:
            - Y
            - N
          default: N
        use_available_shield_start_date:
          type: string
          description: Shield使用開始日
        use_available_shield_end_date:
          type: string
          description: Shield使用終了日
        use_permission_bulk_upload:
          type: string
          description: 共有者一括登録の使用可否
          enum:
            - Y
            - N
          default: N
        use_available_versioning:
          type: string
          description: 履歴管理(versioning)、使用可否(admin)
          enum:
            - Y
            - N
          default: Y
        available_versioning_limit:
          type: number
          description: 履歴管理ファイルの最大履歴数(boxadmin)
          default: 10
        use_available_shield_user_count:
          type: string
          description: SHIELD ユーザー数
        use_available_fax:
          type: string
          description: FAX 連携サービスの使用可否
          enum:
            - Y
            - N
          default: N
        fax_vendor_code:
          type: string
          description: FAX 連携サービス vendor_code
        use_available_ocr:
          type: string
          description: AI OCR使用の可否
          enum:
            - Y
            - N
          default: N
        use_available_ocr_start_date:
          type: string
          description: OCR使用開始日
        use_available_ocr_end_date:
          type: string
          description: OCR使用終了日
        use_available_api_key:
          type: string
          description: OpenAPI使用の可否
          enum:
            - Y
            - N
          default: N
        use_available_api_key_limit:
          type: number
          description: |
            OpenAPI Request制限値

            ファイルリスト及びフォルダリストの照会リクエスト数は、月単位で制限があります。
            価格体系によるリクエスト数の制限は以下の通りです。
            - **10,000**: FREE
            - **100,000**: Business
            - **200,000**: Premium
            - **300,000**: Enterprise
          enum:
            - 10000
            - 30000
            - 100000
            - 200000
            - 300000
        use_available_api_key_start_date:
          type: string
          description: OpenAPI使用開始日
        use_available_api_key_end_date:
          type: string
          description: OpenAPI使用終了日
        use_available_custom_domain:
          type: string
          description: 회사별 독립 도메인 사용 여부
        use_available_connect:
          type: string
          description: Connect 사용 여부
          enum:
            - Y
            - N
          default: N
        use_available_connect_start_date:
          type: string
          description: Connect 사용 시작 날짜
        use_available_connect_end_date:
          type: string
          description: Connect 사용 종료 날짜
        use_available_connect_limit:
          type: number
          description: Connect 폴더 1계층 생성 제한 수
          default: 1000
        use_available_salesforce:
          type: string
          description: Salesforce 연계 사용 여부
          enum:
            - Y
            - N
          default: N
        use_available_salesforce_start_date:
          type: string
          description: Salesforce 사용 시작 날짜
        use_available_salesforce_end_date:
          type: string
          description: Salesforce 사용 종료 날짜
        use_available_web_chat:
          type: string
          description: TALK+ 사용 여부
          enum:
            - Y
            - N
          default: N
        use_available_web_chat_start_date:
          type: string
          description: TALK+ 사용 시작 날짜
        use_available_web_chat_end_date:
          type: string
          description: TALK+ 사용 종료 날짜
        trash_expiration_type:
          type: string
          description: |
            ゴミ箱 削除期間
            - 0 : 基本
            - 1 : 無制限
          enum:
            - 0
            - 1
          default: 0
        use_company_trash:
          type: string
          description: 会社のゴミ箱の使用可否
          enum:
            - Y
            - N
          default: N
        company_trash_expiration_type:
          type: string
          description: |
            会社ゴミ箱 削除期間
            - 0 : 最大3日
            - 1 : 最大無制限
            - 30 : 最大30日
          enum:
            - 0
            - 1
            - 30
          default: 0
        use_security:
          type: string
          description: 企業セキュリティ使用可否
          enum:
            - Y
            - N
          default: Y
        use_available_ldap:
          type: string
          description: Box AdminでSSOを使用可否
          enum:
            - Y
            - N
          default: N
        sso_item:
          type: string
          description: |
            SSO 商品情報
            - all : 全体
            - lite : Sateraito、G-Suiteのみ提供
          enum:
            - all
            - lite
          default: all
        use_manager_log:
          type: string
          description: 管理者ログの使用可否
          enum:
            - Y
            - N
          default: N
        use_available_drive:
          type: string
          description: PCドライブ使用可否
          enum:
            - Y
            - N
          default: N
        viewer:
          type: string
          description: |
            使用中のビューアータイプ
            - onlyoffice
            - prizmdoc
            - vidoc
        use_talk:
          type: string
          description: Talk使用可否
          enum:
            - Y
            - N
          default: N
        talk_start_date:
          type: string
          description: TALK開始日
          example: "2021-08-16"
        talk_end_date:
          type: string
          description: TALK終了日
          example: "2022-08-16"
        talk_user_count:
          type: number
          description: TALKユーザー数
          example: 50
        talk_custom_field01:
          type: string
          description: TALKログ保管日
        comment:
          type: string
          description: メモ

      example:
        company_seq: 12305
        name: DirectCloud
        phone: 03-4405-3668
        company_email: support@directcloud.co.jp
        contact_name: "John"
        id: johndoe
        password: "1111111"
        email: john@directcloud.jp
        cell_phone: 123-4567-8900
        item_code: Enterprise
        post_no: 105-0021
        address: 日本、〒105-0021 東京都港区東新橋２丁目１２−１
        scale: 1 - 50名
        country_code: jpn
        gmt: " +9" # TODO: Check
        admin_seq: 54321
        use_trial: N
        start_date: "2021-08-16"
        end_date: "2026-09-09"
        use_campaign: Y
        campaign_end_date: "2021-12-12"
        status: 11
        payment_type: yearly
        volume_size: 10995116277760
        limit_traffic: 10737418240
        max_upload_size: 10737418240
        max_preview_size: 209715200
        max_media_preview_size: 734003200
        license_amount: 100
        csv_upload_limit: 5000
        use_my_box: Y
        use_shared_box: Y
        use_tag: N
        use_available_comment: N
        use_available_guest_invite: Y
        flag_quota_limit: N
        use_available_master: N
        use_available_master_start_date: "2021-08-16"
        use_available_master_end_date: "2026-09-09"
        use_available_master_user_count: 5
        use_available_master_permission_detail: Y
        flag_uploadrequest: Y
        use_available_otp: Y
        use_available_offline: N
        use_zipmail: Y
        use_available_domain: N
        use_available_wf: Y
        use_available_smtp: Y
        use_available_file_permission: N
        use_two_factor_sms: N
        use_session_log: Y
        use_finder: Y
        use_available_editor: Y
        use_available_editor_start_date: "2021-08-16"
        use_available_editor_end_date: "2026-09-09"
        use_upload_alarm_one_term: N
        use_available_link_default: N
        use_available_upload_alarm_custom: N
        use_available_audit: N
        use_dashboard: N
        use_dashboard_extension: N
        use_dashboard_start_date: "2021-08-16"
        use_dashboard_end_date: "2026-09-09"
        use_available_shield: Y
        use_available_shield_extension: Y
        use_available_shield_start_date: "2021-08-16"
        use_available_shield_end_date: "2026-09-09"
        use_permission_bulk_upload: Y
        use_available_versioning: Y
        available_versioning_limit: 100
        use_available_fax: N
        fax_vendor_code: NTTCW
        use_available_ocr: Y
        use_available_ocr_start_date: "2021-08-16"
        use_available_ocr_end_date: "2026-09-09"
        use_available_api_key: Y
        use_available_api_key_limit: 300000
        use_available_api_key_start_date: "2021-08-16"
        use_available_api_key_end_date: "2026-09-09"
        use_available_custom_domain: N
        use_available_connect: Y
        use_available_connect_start_date: "2021-08-16"
        use_available_connect_end_date: "2026-09-09"
        use_available_connect_limit: 1000
        use_available_salesforce: Y
        use_available_salesforce_start_date: "2021-08-16"
        use_available_salesforce_end_date: "2026-09-09"
        use_available_web_chat: Y
        use_available_web_chat_start_date: "2021-08-16"
        use_available_web_chat_end_date: "2026-09-09"
        trash_expiration_type: 0
        use_company_trash: Y
        company_trash_expiration_type: 30
        use_security: Y
        use_available_ldap: Y
        sso_item: all
        use_manager_log: Y
        use_available_drive: N
        viewer: onlyoffice
        use_talk: Y
        talk_start_date: "2021-08-16"
        talk_end_date: "2022-08-16"
        talk_user_count: 50
        talk_custom_field01: 365
        comment: "DirectCloud HQ"

    CompanyEdit:
      type: object
      properties:
        name:
          type: string
          description: 会社名
        phone:
          type: string
          description: 電話番号
        company_email:
          type: string
          description: 代表メールアドレス
        contact_name:
          type: string
          description: 契約担当者の名前
        password:
          type: string
          description: 契約担当者パスワード
        email:
          type: string
          description: 契約担当者メール
        cell_phone:
          type: string
          description: 契約担当者の電話番号
        item_code:
          type: string
          description: 締結契約(製品プラン)
        post_no:
          type: string
          description: 郵便番号
        address:
          type: string
          description: 住所
        scale:
          type: string
          description: 会社規模
          enum:
            - "1 - 50名"
            - "51 -　100名"
            - "101 - 500名"
            - "500 - 1,000名"
            - "1,000名以上"
        country_code:
          type: string
          description: 国家コード
          default: jpn
        gmt:
          type: string
          description: GMT(Grennwich Mean Time) 情報
          default: " +9" # TODO: finish me
        admin_seq:
          type: number
          description: 販売会社の固有番号
        use_trial:
          type: string
          description: 体験版(Trial) 使用可否(boxadmin)
          enum:
            - Y
            - N
          default: N
        start_date:
          type: string
          description: 使用開始日
          example: "2021-08-16"
        end_date:
          type: string
          description: 使用終了日
          example: "2026-09-09"
        use_compaign:
          type: string
          description: キャンペーン使用可否
          enum:
            - Y
            - N
          default: Y
        compaign_end_date:
          type: string
          description: キャンペーン終了日
        status:
          type: string
          description: |
            常態
            - 0 : 未認証
            - 10 : 無料
            - 11 : 有料
            - 41 : 使用停止
            - 91 : 削除
            - 92 : 脱退
        payment_type:
          type: string
          description: 支払方法
          enum:
            - yearly
            - monthly
            - no_charge
          default: monthly
        volume_size:
          type: number
          description: 容量(Byte)
          default: 0
        limit_traffic:
          type: number
          description: トラフィック(Byte)
        #          default: 10737418240
        max_upload_size:
          type: number
          description: 最大アップロードサイズ(Byte)
        #          default: 5368709120
        max_preview_size:
          type: number
          description: プレビューできる最大サイズ(Byte)
        #          default: 31457280
        max_media_preview_size:
          type: number
          description: メディアプレビュー可能な最大サイズ(Byte)
        #          default: 10737418240
        license_amount:
          type: string
          description: |
            ユーザー制限数
            - **0**: 無制限
        csv_upload_limit:
          type: number
          description: CSV一括登録アップロード行数制限(500~10,000)
        use_my_box:
          type: string
          description: My Box 使用の可否
          enum:
            - Y
            - N
          default: Y
        use_shared_box:
          type: string
          description: Shared Box 使用の可否
          enum:
            - Y
            - N
          default: N
        use_tag:
          type: string
          description: タグ機能の使用可否
          enum:
            - Y
            - N
          default: N
        use_available_comment:
          type: string
          description: ファイル別コメント使用可否
          enum:
            - Y
            - N
          default: N
        use_available_guest_invite:
          type: string
          description: Guest招待使用可否
          enum:
            - Y
            - N
          default: N
        flag_quota_limit:
          type: string
          description: Shared Box容量制限/自動削除の使用可否
          enum:
            - Y
            - N
          default: N
        use_available_master:
          type: string
          description: Shared Box マスター権限使用可否
          enum:
            - Y
            - N
          default: N
        use_available_master_start_date:
          type: string
          description: Shared Box副管理者権限使用開始日
        use_available_master_end_date:
          type: string
          description: Shared Box副管理者権限使用終了日
        use_available_master_user_count:
          type: number
          description: Shared Box副管理者最大数
        use_available_master_permission_detail:
          type: string
          description: Shared Box副管理者権限詳細設定
          enum:
            - Y
            - N
          default: N
        flag_uploadrequest:
          type: string
          description: アップロードリクエストの使用可否
          enum:
            - Y
            - N
          default: N
        use_avialable_otp:
          type: string
          description: 2段階認証(email)の使用可否
          enum:
            - Y
            - N
          default: N
        use_available_offline:
          type: string
          description: モバイルオフライン使用可否
          enum:
            - Y
            - N
          default: N
        use_zipmail:
          type: string
          description: ファイル添付メール送信の使用可否
          enum:
            - Y
            - N
          default: N
        use_available_domain:
          type: string
          description: 会社別サブドメイン使用可否
          enum:
            - Y
            - N
          default: N
        use_available_wf:
          type: string
          description: ワークフロー使用可否
          enum:
            - Y
            - N
          default: N
        use_available_smtp:
          type: string
          description: 会社別メール送信サーバー使用可否
          enum:
            - Y
            - N
          default: N
        use_available_file_permission:
          type: string
          description: ファイルロックの使用可否
          enum:
            - Y
            - N
          default: Y
        use_two_factor_sms:
          type: string
          description: 2段階認証(SMS)使用可否
          enum:
            - Y
            - N
          default: N
        use_session_log:
          type: string
          description: セッション履歴の使用可否
          enum:
            - Y
            - N
          default: N
        use_finder:
          type: string
          description: 全文検索の使用可否
          enum:
            - Y
            - N
          default: N
        use_available_editor:
          type: string
          description: 共同文書編集の使用可否
          enum:
            - Y
            - N
          default: N
        use_available_editor_start_date:
          type: string
          description: オンライン編集の使用開始日付
        use_available_editor_end_date:
          type: string
          description: オンライン編集の使用終了日付
        use_upload_alarm_one_term:
          type: string
          description: 通知メール1分ごとに通知使用可否
          enum:
            - Y
            - N
          default: N
        use_available_link_default:
          type: string
          description: リンク初期値オプション高度化使用可否
          enum:
            - Y
            - N
          default: N
        use_available_upload_alarm_custom:
          type: string
          description: 新規ファイルアップロード通知メールカスタム
          enum:
            - Y
            - N
          default: N
        use_available_audit:
          type: string
          description: 監査エディション
          enum:
            - Y
            - N
          default: N
        use_dashboard:
          type: string
          description: ダッシュボード使用可否
          enum:
            - Y
            - N
          default: N
        use_dashboard_extension:
          type: string
          description: ダッシュボード詳細使用可否
          enum:
            - Y
            - N
          default: N
        use_dashboard_start_date:
          type: string
          description: ダッシュボード(VISIBLE)詳細使用開始日付
        use_dashboard_end_date:
          type: string
          description: ダッシュボード(VISIBLE)詳細使用終了日付
        use_available_shield:
          type: string
          description: SHIELD使用可否(Boxadmin)
          enum:
            - Y
            - N
          default: N
        use_available_shield_extension:
          type: string
          description: SHIELD正式版の使用可否
          enum:
            - Y
            - N
          default: N
        use_available_shield_start_date:
          type: string
          description: Shield使用開始日付
        use_available_shield_end_date:
          type: string
          description: Shield使用終了日付
        use_permission_bulk_upload:
          type: string
          description: 共有者一括登録の使用可否
          enum:
            - Y
            - N
          default: N
        use_available_versioning:
          type: string
          description: 履歴管理(versioning)、使用可否(admin)
          enum:
            - Y
            - N
          default: Y
        available_versioning_limit:
          type: number
          description: 履歴管理ファイルの最大履歴数(boxadmin)
          default: 10
        use_available_shield_user_count:
          type: string
          description: SHIELD ユーザー数
        use_available_fax:
          type: string
          description: FAX 連携サービスの使用可否
          enum:
            - Y
            - N
          default: N
        fax_vendor_code:
          type: string
          description: FAX 連携サービス vendor_code
        use_available_ocr:
          type: string
          description: AI OCR使用の可否
          enum:
            - Y
            - N
          default: N
        use_available_ocr_start_date:
          type: string
          description: OCR使用開始日付
        use_available_ocr_end_date:
          type: string
          description: OCR使用終了日付
        use_available_api_key:
          type: string
          description: OpenAPI使用の可否
          enum:
            - Y
            - N
          default: N
        use_available_api_key_limit:
          type: number
          description: |
            OpenAPI Request制限値

            ファイルリスト及びフォルダリストの照会リクエスト数は、月単位で制限があります。
            価格体系によるリクエスト数の制限は以下の通りです。
            - **10,000**: FREE
            - **100,000**: Business
            - **200,000**: Premium
            - **300,000**: Enterprise
          enum:
            - 10000
            - 30000
            - 100000
            - 200000
            - 300000
        use_available_api_key_start_date:
          type: string
          description: OpenAPI使用開始日付
        use_available_api_key_end_date:
          type: string
          description: OpenAPI使用終了日付
        use_available_custom_domain:
          type: string
          description: 会社別の独立ドメインを使用可否
        use_available_connect:
          type: string
          description: Connect使用可否
          enum:
            - Y
            - N
          default: N
        use_available_connect_start_date:
          type: string
          description: Connect使用開始日
        use_available_connect_end_date:
          type: string
          description: Connect使用終了日
        use_available_connect_limit:
          type: number
          description: Connectフォルダ1階層生成制限数
          default: 1000
        use_available_salesforce:
          type: string
          description: Salesforce連携使用の可否
          enum:
            - Y
            - N
          default: N
        use_available_salesforce_start_date:
          type: string
          description: Salesforce使用開始日
        use_available_salesforce_end_date:
          type: string
          description: Salesforce使用終了日
        use_available_web_chat:
          type: string
          description: TALK+使用可否
          enum:
            - Y
            - N
          default: N
        use_available_web_chat_start_date:
          type: string
          description: TALK+使用開始日
        use_available_web_chat_end_date:
          type: string
          description: TALK+使用終了日
        trash_expiration_type:
          type: string
          description: |
            ゴミ箱 削除期間
            - 0 : 基本
            - 1 : 無制限
          enum:
            - 0
            - 1
          default: 0
        use_company_trash:
          type: string
          description: 会社のゴミ箱の使用可否
          enum:
            - Y
            - N
          default: N
        company_trash_expiration_type:
          type: string
          description: |
            会社ゴミ箱 削除期間
            0 : 最大3日
            1 : 最大無制限
            30 : 最大30日
          enum:
            - 0
            - 1
            - 30
          default: 0
        use_security:
          type: string
          description: 企業セキュリティ使用可否
          enum:
            - Y
            - N
          default: Y
        use_available_ldap:
          type: string
          description: Box AdminでSSOを使用可否
          enum:
            - Y
            - N
          default: N
        sso_item:
          type: string
          description: |
            SSO商品情報
            - all : 全体
            - lite : Sateraito, G-Suiteのみ提供
          enum:
            - all
            - lite
          default: all
        use_manager_log:
          type: string
          description: 管理者ログの使用可否
          enum:
            - Y
            - N
          default: N
        use_available_drive:
          type: string
          description: PCドライブ使用可否
          enum:
            - Y
            - N
          default: N
        viewer:
          type: string
          description: |
            使用中のビューアータイプ
            - onlyoffice
            - prizmdoc
            - vidoc
        use_talk:
          type: string
          description: Talk使用の可否
          enum:
            - Y
            - N
          default: N
        talk_start_date:
          type: string
          description: TALK開始日
          example: "2021-08-16"
        talk_end_date:
          type: string
          description: TALK終了日
          example: "2022-08-16"
        talk_user_count:
          type: number
          description: TALKユーザー数
          example: 50
        talk_custom_field01:
          type: string
          description: TALKログ保管日
        comment:
          type: string
          description: メモ
      example:
        name: DirectCloud
        phone: 03-4405-3668
        company_email: support@directcloud.co.jp
        contact_name: "John"
        password: "1111111"
        eamil: john@directcloud.jp
        cell_phone: 123-4567-8900
        item_code: Enterprise
        post_no: 105-0021
        address: 日本、〒105-0021 東京都港区東新橋２丁目１２−１
        scale: 1 - 50名
        country_code: jpn
        gmt: " +9" # TODO: Check
        admin_seq: 54321
        use_trial: N
        start_date: "2021-08-16"
        end_date: "2026-09-09"
        use_campaign: Y
        campaign_end_date: "2021-12-12"
        status: 11
        payment_type: yearly
        volume_size: 10995116277760
        limit_traffic: 10737418240
        max_upload_size: 10737418240
        max_preview_size: 209715200
        max_media_preview_size: 734003200
        license_amount: 100
        csv_upload_limit: 5000
        use_my_box: Y
        use_shared_box: Y
        use_tag: N
        use_available_comment: N
        use_available_guest_invite: Y
        flag_quota_limit: N
        use_available_master: N
        use_available_master_start_date: "2021-08-16"
        use_available_master_end_date: "2026-09-09"
        use_available_master_user_count: 5
        use_available_master_permission_detail: Y
        flag_uploadrequest: Y
        use_available_otp: Y
        use_available_offline: N
        use_zipmail: Y
        use_available_domain: N
        use_available_wf: Y
        use_available_smtp: Y
        use_available_file_permission: N
        use_two_factor_sms: N
        use_session_log: Y
        use_finder: Y
        use_available_editor: Y
        use_available_editor_start_date: "2021-08-16"
        use_available_editor_end_date: "2026-09-09"
        use_upload_alarm_one_term: N
        use_available_link_default: N
        use_available_upload_alarm_custom: N
        use_available_audit: N
        use_dashboard: N
        use_dashboard_extension: N
        use_dashboard_start_date: "2021-08-16"
        use_dashboard_end_date: "2026-09-09"
        use_available_shield: Y
        use_available_shield_extension: Y
        use_available_shield_start_date: "2021-08-16"
        use_available_shield_end_date: "2026-09-09"
        use_available_shield_user_count: 20
        use_permission_bulk_upload: Y
        use_available_versioning: Y
        available_versioning_limit: 100
        use_available_fax: N
        fax_vendor_code: NTTCW
        use_available_ocr: Y
        use_available_ocr_start_date: "2021-08-16"
        use_avaialble_ocr_end_date: "2026-09-09"
        use_available_api_key: Y
        use_available_api_key_limit: 300000
        use_available_api_key_start_date: "2021-08-16"
        use_available_api_key_end_date: "2026-09-09"
        use_available_custom_domain: N
        use_available_connect: Y
        use_available_connect_start_date: "2021-08-16"
        use_available_connect_end_date: "2026-09-09"
        use_available_connect_limit: 1000
        use_available_salesforce: Y
        use_available_salesforce_start_date: "2021-08-16"
        use_available_salesforce_end_date: "2026-09-09"
        use_available_web_chat: Y
        use_available_web_chat_start_date: "2021-08-16"
        use_available_web_chat_end_date: "2026-09-09"
        trash_expiration_type: 0
        use_company_trash: Y
        company_trash_expiration_type: 30
        use_security: Y
        use_available_ldap: Y
        sso_item: all
        use_manager_log: Y
        use_available_drive: N
        viewer: onlyoffice
        use_talk: Y
        talk_start_date: "2021-08-16"
        talk_end_date: "2022-08-16"
        talk_user_count: 50
        talk_custom_field01: 365
        comment: "DirectCloud HQ"
